<script setup lang="ts">
import PaymentGates from '@/components/Payments/PaymentGates.vue'
import { t } from '@/locales/i18n'
import { usePaymentPlan } from '@/composables/paymentPlan'
import GwText from '@/components/lib/base/GwText/GwText.vue'

const { selectedTierPlan, gm_type } = usePaymentPlan()

interface PaymentMethodSelectionProps {
  errorNoCard: boolean
  upgradePrice: number
  startGate: string
  onSuccessPayment: (params: { payment_provider: string; payment_method: string }) => void
}

const props = defineProps<PaymentMethodSelectionProps>()
</script>

<template>
  <div class="d-flex f-column ga-2">
    <div
      v-if="errorNoCard"
      class="d-flex mx-auto w-100 justify-center ga-2 mb-2"
    >
      <i
        class="my-auto mdi mdi-alert-circle-outline text-red"
        style="font-size: 3.5rem"
      />
      <GwText
        variant="text_white_normal_500"
        style="--text-size: 1.25rem; --text-clr: var(--clr-error)"
        class="my-auto"
        v-html="t('subscription.selection_no_card_text')"
      />
    </div>
    <div class="d-flex f-column align-center justify-center text-center">
      <GwText
        variant="text_white_normal_500"
        style="--text-weight: 700; --text-size: 1.375rem"
        class="mb-1"
      >
        {{ $t(`gametypes.groups.${gm_type}_long`) }} /
        {{ selectedTierPlan.full_name }}
      </GwText>
      <GwText
        variant="text_white_normal_500"
        style="--text-size: 1.25rem"
        class="text-bold clr-primary"
      >
        {{ upgradePrice }} USD
      </GwText>
    </div>
    <div class="mx-auto mb-4">
      <PaymentGates
        class="mt-2"
        :onSuccessPayment="props.onSuccessPayment"
        :startGate
      />
    </div>
  </div>
</template>
